import React, { createContext, ReactNode, useEffect, useMemo } from 'react';
import { createTheme } from '@material-ui/core/styles';
import MuiThemeProvider from '@material-ui/styles/ThemeProvider';
import { useCookie } from 'react-use';
import {
  COLOR_ENGAGEMENT,
  COLOR_USER,
  FONT_FAMILY,
  FONT_SIZE,
} from '../styles';

interface Value {
  theme: Theme;
  setTheme: (val: Theme) => void;
}

export const ThemeContext = createContext<Value>(null as any);

interface Props {
  children: ReactNode;
}

export enum Theme {
  LIGHT,
  DARK,
  CONTRAST,
}

export function ThemeProvider({ children }: Props) {
  const [themeValue = Theme.LIGHT, setTheme] = useCookie('theme');
  const theme = Number(themeValue);
  const value = useMemo<Value>(
    () => ({
      theme,
      setTheme: (val: Theme) => {
        //useCookie expects a string as a value
        setTheme(val.toString());
      },
    }),
    [theme, setTheme],
  );

  useEffect(() => {
    const rootElement = document.querySelector(':root');
    if (!rootElement) return;
    rootElement.classList.toggle('dark', theme === Theme.DARK);
    rootElement.classList.toggle('contrast', theme === Theme.CONTRAST);
  }, [theme]);

  const muiTheme = useMemo(
    () =>
      createTheme({
        palette: {
          type: theme === Theme.LIGHT ? 'light' : 'dark',
          primary: {
            main: COLOR_USER,
          },
          secondary: {
            main: COLOR_ENGAGEMENT,
          },
        },
        typography: {
          fontFamily: FONT_FAMILY,
          fontSize: parseInt(FONT_SIZE, 10),
        },
      }),
    [theme],
  );

  return (
    <MuiThemeProvider theme={muiTheme}>
      <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
    </MuiThemeProvider>
  );
}
